export const motion = {
  durations: { fast: '120ms', medium: '200ms', slow: '320ms' },
  easing: {
    standard: 'cubic-bezier(0.2, 0, 0, 1)',
    emphasized: 'cubic-bezier(0.2, 0, 0, 1.2)',
    linear: 'linear',
  },
} as const;
